import { Component } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { forkJoin, from, Subscription } from 'rxjs';
import { UsuarioService } from './shared/services/usuario.service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { PermissoesService } from './shared/services/permissoes.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private userProfileSub: Subscription | null;

  constructor(
    private router: Router,
    private oauthService: OAuthService,
    private usuarioService: UsuarioService,
    private permissoesService: PermissoesService
  ) {
    this.userProfileSub = null;
  }

  private authCodeFlowConfig: AuthConfig = {
    issuer: environment.soe.issuer,
    redirectUri: environment.soe.redirectUri,
    logoutUrl: environment.soe.redirectUri,
    clientId: environment.soe.clientId,
    responseType: 'code',
    scope: 'openid',
    showDebugInformation: false,
    requireHttps: false,
  };

  ngOnInit(): void {
    this.oauthService.configure(this.authCodeFlowConfig);
    this.oauthService.setupAutomaticSilentRefresh();

    this.oauthService.loadDiscoveryDocument().then(() => {
      this.oauthService.tryLoginCodeFlow().then(() => {
        if (this.oauthService.hasValidAccessToken()) {
          this.userProfileSub = forkJoin({
            credencialSoe: from(this.oauthService.loadUserProfile()),
            permissoes: this.permissoesService.getPermissoes(),
          }).subscribe((resultado) => {
            let usuario: any = resultado.credencialSoe;
            usuario.permissoes = resultado.permissoes;

            this.usuarioService.setUsuario(usuario);

            if (!environment.production) console.log(usuario);

            this.router.navigate(['/main', 'home']);
          });
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.userProfileSub?.unsubscribe();
  }
}
